<div class="stacking-results-container container">
  <div class="swipe-block" :style="style">
    <p class="title">Staking stats</p>
    <section class="results">
      <div class="item left-item">
        <div class="label label-left">Total Staked</div>
        <!--        <tw-loader v-if="+totalStakedInCgu === 0 || +totalStakedInUsdt === 0" class="loader"/>-->
        <!--        <template>-->
        <div class="value">
          {{ totalStakedInCguFormatted }} <span class="value-token">CGU</span>
        </div>
        <div class="value">
          {{ totalStakedInUsdtFormatted }} <span class="value-token">USDT</span>
        </div>
        <div class="subvalue">${{ stakedUsd }}</div>
        <!--        </template>-->
      </div>
      <div class="item right-item">
        <div class="">
          <div class="label">Tokens Distributed</div>
          <div v-if="totalRewardsInCgu" class="value">{{ totalRewardsInCgu }} <span class="value-token">CGU</span></div>
          <skeleton v-else />
          <div v-if="totalRewardsInCgu" class="subvalue">${{ totalRewardsInUsd }}</div>
          <skeleton v-else />
        </div>
      </div>
      <div class="item right-item">
        <div class="">
          <div class="label">APY</div>
          <div class="value">5-20%</div>
        </div>
      </div>
      <div class="item right-item">
        <div class="">
          <div class="label">Stakers</div>
          <div class="value">{{ stakers }}</div>
        </div>
      </div>
    </section>
  </div>
</div>
